import React, {useState} from 'react';
import {__, _nonce} from '../../../assets/javascripts/library.js';
import { ToasterProvider } from "../global-components/toaster.jsx";
import {FinalValidator, SelectedAddons} from "../../../assets/javascripts/registration-validator.js";
import ReactDOM from "react-dom/client";
import AlreadyExistsContainer from "../event-registration/after-submit/alreadyexist.jsx";
import SuccessContainer from "../event-registration/after-submit/success.jsx";
import {autoSetDates, NewEventValidator} from "../../../assets/javascripts/event-settings-validator.jsx";
import Settings from "../events/partials/settings.jsx";
import ParticipationFees from "../events/partials/participation-fees.jsx";

function NewEvent() {
    const { default_data } = window.solea_data;


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));

        if ('date_begin' === name) {
            autoSetDates();
            formData.date_end = document.getElementById('date_end').value;
            formData.last_minute_begin = document.getElementById('last_minute_begin').value;
            formData.registration_end = document.getElementById('registration_end').value;
        }
    };

    const handleCheckboxChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.checked,
        }));
    };

    const [formData, setFormData] = useState({
        event_name: '',
        event_location: '',
        date_begin: '',
        date_end: '',
        last_minute_begin: '',
        registration_end: '',
        event_email: default_data.email,
        payment_direct: '',
        account_iban: default_data.account_iban,
        account_owner: default_data.account_owner,
    });


    const create_event = (api_url, formData) => {
        const response = fetch(api_url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                formData,
                solea_nonce: _nonce(),
            }),
        }).then((res) => res.json())
            .then((data) => {
                const container = document.getElementById('main-content');
                const root = ReactDOM.createRoot(container);
                root.render(
                    <ToasterProvider>
                        <div id="solea_event_group_contents">
                            <ParticipationFees event={data.event} toast_message={data.message} />
                        </div>
                    </ToasterProvider>
                );
            });
    }

    const createSolidarityBasedEvent = (e) => {
        if (!NewEventValidator()) {
            return;
        }

        create_event("/wp-json/solea/new-event/save/solidarity-based", formData);
    }

    const createGroupBasedEvent = (e) => {
        if (!NewEventValidator()) {
            return;
        }

        create_event("/wp-json/solea/new-event/save/group-based", formData);
    }


    return(
        <div className="solea-page">
            <h3>{__('Basic event data', 'solea')}</h3>
            <table id="solea_new_event_basic_data">
                <tr>
                    <td>
                        {__('Event name', 'solea')}:
                    </td>
                    <td>
                        <input id="event_name" type="text" name="event_name" onChange={handleChange} />
                    </td>

                </tr>

                <tr>
                    <td>
                        {__('Event location', 'solea')}:
                    </td>
                    <td>
                        <input id="event_location" type="text" name="event_location" onChange={handleChange} />
                    </td>
                </tr>

                <tr>
                    <td>
                        {__('Event email', 'solea')}:
                    </td>
                    <td>
                        <input defaultValue={default_data.email} id="event_email" type="email" name="event_email" onChange={handleChange} />
                    </td>
                </tr>

                <tr>
                    <td>
                        {__('Event begin', 'solea')}:
                    </td>
                    <td>
                        <input id="date_begin" type="date" name="date_begin" onChange={handleChange} />
                    </td>
                </tr>


                <tr>
                    <td>
                        {__('Event end', 'solea')}:
                    </td>
                    <td>
                        <input id="date_end" type="date" name="date_end" onChange={handleChange} />
                    </td>
                </tr>

                <tr>
                    <td>
                        {__('Begin last-minute registration', 'solea')}:
                    </td>
                    <td>
                        <input id="last_minute_begin" type="date" name="last_minute_begin" onChange={handleChange} />
                    </td>
                </tr>

                <tr>
                    <td>
                        {__('Latest registration end', 'solea')}:
                    </td>
                    <td>
                        <input id="registration_end" type="date" name="registration_end" onChange={handleChange} />
                    </td>
                </tr>

                <tr>
                    <td>
                        {__('Event account owner', 'solea')}:
                    </td>
                    <td>
                        <input defaultValue={default_data.account_owner} id="account_owner" type="text" name="account_owner" onChange={handleChange} />
                    </td>
                </tr>

                <tr>
                    <td>
                        {__('Event account IBAN', 'solea')}:
                    </td>
                    <td>
                        <input defaultValue={default_data.account_iban} id="account_iban" type="text" name="account_iban" onChange={handleChange} />
                    </td>
                </tr>

                <tr>
                    <td colSpan="2">
                        <input type="checkbox" name="payment_direct" onChange={handleCheckboxChange} id="payment_direct" class="mr-10" />
                        <label for="payment_direct">
                            {__('Participants pay direct to event account', 'solea')}
                        </label>
                    </td>
                </tr>
                <tr><td colSpan="2">&nbsp;</td></tr>


                <tr>
                    <td colSpan="2" class="ta-center">
                        <button onClick={createSolidarityBasedEvent} className="button solea-button mr-10">
                            {__('Solidarity based registration', 'solea')}
                        </button>

                        <button onClick={createGroupBasedEvent} className="button solea-button mr-10">
                            {__('Group based registration', 'solea')}
                        </button>
                    </td>
                </tr>
            </table>
        </div>
    )
}

export default NewEvent;